import { render } from "./Profile-general.vue?vue&type=template&id=55e6eda0&scoped=true&lang=pug"
import script from "./Profile-general.vue?vue&type=script&setup=true&lang=js"
export * from "./Profile-general.vue?vue&type=script&setup=true&lang=js"

import "./Profile-general.vue?vue&type=style&index=0&id=55e6eda0&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e6eda0"]])

export default __exports__